import React from "react";
import "./revenue.css";
import * as FeatherIcon from "react-feather";
import { ICONS, SUB } from "./dimIcons";

export default function LeftNav({ dimensions = [], activeKey, onSelect }) {
  return (
    <div className="rt-left">
      <div className="head">Analysis Dimensions</div>
      <div className="rt-divider"></div>
      <div className="body">
        {dimensions.map(d => {
          const active = d.key === activeKey;
          const IconComp = ICONS[d.key] || FeatherIcon.Circle; // fallback icon

          return (
            <button
              key={d.key}
              type="button"
              className={`dim-item ${active ? "active" : ""}`}
              onClick={() => onSelect?.(d.key)}
            >
              {/* Feather icon */}
              <IconComp className="dim-icon fa" style={{ width: 18, marginRight: 10 }} />

              <div className="text-start">
                <div className="dim-title">{d.label}</div>
                <div className="dim-sub">{SUB[d.key] || ""}</div>
              </div>
              <FeatherIcon.ChevronRight className="dim-arrow" size={22} />
            </button>
          );
        })}

      </div>
    </div>
  );
}
